import { SafeJSON } from './../shared/safe-json';

export class CivilIdentityOtherData {
    json: any;

    // variables used during requesting this object
    errorMessage: string = null;

    constructor(json: any) {
      this.json = json;
    }

    getOpposingPartyName(): string {
      return SafeJSON.get('opposingPartyName', this.json);
    }
    getOpposingOtherPartyCount(): number {
      return SafeJSON.get('opposingOtherPartyCount', this.json);
    }
    getOpposingPartyAliasCount(): number {
      return SafeJSON.get('opposingPartyAliasCount', this.json);
    }
    getOpposingPartyRole(): string {
      return SafeJSON.get('opposingPartyRole', this.json);
    }
    getOpposingPartyTitle(): string {
      return SafeJSON.get('opposingPartyTitle', this.json);
    }
    getJudgmentStatus(): string {
      return SafeJSON.get('judgmentStatus', this.json);
    }
    getJudgmentLocation(): string {
      return SafeJSON.get('judgmentLocation', this.json);
    }
    getCaseStatus(): string {
      return SafeJSON.get('caseStatus', this.json);
    }
    getInRegardsTo(): string {
      return SafeJSON.get('inRegardsTo', this.json);
    }
    getInRegardsToPartyCount(): number {
      return SafeJSON.get('inRegardsOtherPartyCount', this.json);
    }
    getInRegardsToAliasCount(): number {
      return SafeJSON.get('inRegardsToPartyAliasCount', this.json);
    }
    getInRegardsToPartyRole(): string {
      return SafeJSON.get('inRegardsToPartyRole', this.json);
    }
    getInRegardsToPartyTitle(): string {
      return SafeJSON.get('inRegardsToPartyTitle', this.json);
    }
    getPartyTitle(): string {
      return SafeJSON.get('partyTitle', this.json);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-identity-other-data.ts